import React from 'react';
import MenuItem from './MenuItem';

const MenuBar = ({
  items = [],
  ariaLabel,
  isEmphasised
}) => React.createElement("ul", {
  role: "menubar",
  "aria-label": ariaLabel,
  className: "page-menu__item-list"
}, items.map((link, i) => React.createElement(MenuItem, {
  item: link,
  key: i,
  isEmphasised: isEmphasised
})));

export default MenuBar;